<template>
    <GetStartedLayout :errors="errors" title="Create an Account">
        <v-col class="white--text text-center" cols="12" tag="h1">
            <v-card class="soli-round mx-auto" max-width="450">
                <v-container class="pa-5">
                    <v-container style="max-width: 375px">
                        <GoogleSignIn :errors="errors" register divider />

                        <v-form
                            @submit.prevent="submit"
                            ref="form"
                            class="mx-auto"
                        >
                            <NewEmail
                                v-model="form.email"
                                :errors="errors.email"
                                hideDetails
                                autofocus
                                @keydown.enter="
                                    $refs.password.$refs.password.focus()
                                "
                            />
                            <NewPassword
                                class="pt-3"
                                v-model="form.password"
                                :errors="errors.password"
                                hideDetails
                                ref="password"
                                @keydown.enter="submit"
                            />
                        </v-form>
                    </v-container>
                    <p v-if="errors" class="caption red--text mx-auto">
                        {{ Object.values(errors)[0] }}
                    </p>
                    <v-container class="mt-2">
                        <SoliBtn
                            type="submit"
                            text="Continue"
                            :loading="loading"
                            @click="
                                submit()
                            " /></v-container></v-container></v-card
        ></v-col>
    </GetStartedLayout>
</template>

<script>
import GetStartedLayout from "../../Layouts/GetStartedLayout.vue";
import NewEmail from "../../Components/GetStarted/NewEmail.vue";
import NewPassword from "../../Components/GetStarted/NewPassword.vue";
import GoogleSignIn from "../../Components/Google/GoogleSignIn.vue";
import { Link } from "@inertiajs/vue2";

export default {
    components: {
        GetStartedLayout,
        Link,
        NewEmail,
        GoogleSignIn,
        NewPassword,
    },
    props: {
        errors: {},
        user: {},
    },
    name: "Register",
    data: function () {
        return {
            form: this.$inertia.form({
                email: null,
                password: null,
            }),
            loading: false,
        };
    },
    methods: {
        submit() {
            this.loading = true;
            if (!this.$refs.form.validate()) return;

            this.form.post("/register", {
                onError: () => {
                    console.log(
                        "Form returned errors: " + JSON.stringify(this.errors)
                    );
                    this.loading = false;
                },
            });
        },
    },
};
</script>

<style scoped></style>
